// App.jsx
// TK 10/12/2k22

// Packages, dependencies, and library functions
import React, { useEffect } from "react";
import { Route, Routes, BrowserRouter, useNavigate } from "react-router-dom";
import { pickRandomShowablePlant } from "./DatabaseOperations";

// React Components
import Home from "./HomePage/Home";
import PlantBioPage from "./BioPage/BioPage";
import WindowPage from "./WindowPage/WindowPage";
import MePage from "./MePage/MePage";
import Console from "./Console/Console";
import PageNotFound from "./MiscPages/PageNotFound";
import GamePage from "./GamePage/GamePage";
import BattleStage from "./GamePage/battle/BattleStage";

/*******************************************************************************
 * @func RandomPlant (React Component)
 * This component is called whenever the /random URL is displayed. It redirects
 * the page to a random plant
 *
 * @param None
 * @return Null
 *
 * @notes This will redirect the page to a random plant so it's not exactly a
 * real component
 *
 ******************************************************************************/
const RandomPlant = () => {
  const navigate = useNavigate();
  useEffect(() => {
    pickRandomShowablePlant().then(
      ({ plantID }) => {
        navigate("/plant/" + plantID);
      },
      () => {
        navigate("/"); // Nothing showable found — back to the landing page
      }
    );
  }, [navigate]);
  return null;
};

/*******************************************************************************
 * @func App (React Component)
 * Called by ReactDOM.render(), this component is the parent of all the other
 * components in the application.
 *
 * @param None
 * @return The 5 possible components that can be displayed from here are
 * 1. Home (landing page)
 * 2. Random plant redirect
 * 3. Plant Bio Page
 * 4. Not Found
 * 5. Console (or its children)
 *
 * @notes This will grow as we add more sections of the website
 *
 ******************************************************************************/
const App = () => {
  return (
    <div className="min-h-screen bg-global-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/random" element={<RandomPlant />} />
          <Route path="/plant/:id" element={<PlantBioPage />} />
          <Route path="/window/:userId" element={<WindowPage />} />
          <Route path="/me" element={<MePage />} />
          <Route path="/console/*" element={<Console />} />
          <Route path="/game" element={<BattleStage />} />
          <Route path="/game/classic" element={<GamePage />} />
          {/*  Default when nothing else matches */}
          {<Route path="*" element={<PageNotFound />} />}
        </Routes>
      </BrowserRouter>
    </div>
  );
}; // End App

export default App;
